import { useContext, useMemo } from "react";
import { useMainStyles } from "../MillLocalserverMetrics.styles";
import { Box, CircularProgress, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Bar, BarReferences } from "./components";
import { MillNetworkDetailsContext } from "contexts/MillNetworkDetailsContext/MillNetworkDetailsContext";
import RefreshIcon from "@mui/icons-material/Refresh";

const ConnectionBar = () => {
    const mainClasses = useMainStyles();
    const { t } = useTranslation();
    const { statusAverages, loading, refetch } = useContext(MillNetworkDetailsContext);

    const barComponent = useMemo(() => {
        if (loading) {
            return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CircularProgress color="info" size={20} />
                </Box>
            );
        } else {
            return (
                <>
                    <Bar data={statusAverages} />
                    {statusAverages && <BarReferences />}
                </>
            );
        }
    }, [statusAverages, loading]);

    return (
        <div style={{ padding: "0 22px", marginTop: "16px" }}>
            <div className={mainClasses.card}>
                <div className={mainClasses.mainWrapperHeaderTitle}>
                    {t("locations.mill_network_details.bar_title")}
                    <IconButton onClick={async () => await refetch()}>
                        <RefreshIcon />
                    </IconButton>
                </div>
                <div className={mainClasses.cardBody}>{barComponent}</div>
            </div>
        </div>
    );
};

export default ConnectionBar;
